var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/03d2597c8a6f4b636941b9a335c63b81.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3a8c6b6f3e02e73ee451cddb84dbc133.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3b12a004c37363abe693f048026f29c3.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/47b1956155ae75eca3c38b83c4e238c1.js').default;
var scope_4 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/52eacd08f76323b0e319637cde314b92.js').default;
var scope_5 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6b6ca66c6424548f3490118ac30038df.js').default;
var scope_6 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6f56dfef62b4e63ba24898264210318a.js').default;
var scope_7 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/78b096304899800d0fae7bab50054f8d.js').default;
var scope_8 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7b61cb2fca8a694481ce6fbf099df891.js').default;
var scope_9 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/839fb5199cda092e2afc63bc3520397a.js').default;
var scope_10 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9470bca3ff6907966f65c1433e245c3e.js').default;
var scope_11 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a60a2d3abf513d6cb74976bee740bde1.js').default;
var scope_12 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bb371b604cd58d6bdc41f05f30d23fb7.js').default;
var scope_13 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c6d113b5c3dac8235907a1f7b036ef9b.js').default;
var scope_14 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cc90f5a4f8a4140794b00b692165dcc2.js').default;
var scope_15 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_16 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fa9ae554307aebf2e4808c9288459b9c.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14,
scope_15,
scope_16 )
    